export default __webpack_public_path__ + "static/media/variations-card.e85fa44f.png";